import { Segmented } from 'antd';
import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/i18n';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current: SupportedLanguage = i18n.language.startsWith('fr') ? 'fr' : 'en';

  return (
    <Segmented
      size="small"
      value={current}
      onChange={(value) => {
        void i18n.changeLanguage(value as SupportedLanguage);
      }}
      options={SUPPORTED_LANGUAGES.map((code) => ({
        label: code.toUpperCase(),
        value: code,
        // Suppresses the tooltip AntD derives from the label when `title` is
        // left undefined — a `title="EN"` duplicating the visible text is
        // redundant title text, and screen readers may announce it twice.
        // Each radio takes its accessible name from the label text; AntD's
        // Segmented does not forward per-option ARIA, so that is the ceiling.
        title: '',
      }))}
      aria-label={t('a11y.languageSwitcher')}
    />
  );
}
